module.exports = __webpack_public_path__ + "static/img/logo_2.ea99948.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_2.png
// module id = Z9TY
// module chunks = 0